import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '#app/utils/tailwind-merge.ts'

const badgeVariants = cva(
	`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-normal transition-colors select-none`,
	{
		variants: {
			variant: {
				default: `border-transparent bg-brand-pink text-muted-50 hover:bg-brand-deep-pink`,
				secondary: `bg-brand-muted-amethyst border-transparent hover:bg-brand-beige-pink hover:text-black`,
				destructive: `border-transparent bg-danger-bg text-danger-text hover:bg-danger-bg-hover`,
				outline: `border bg-background text-foreground hover:bg-muted-600`,
				info: `border-transparent bg-info-bg text-info-text hover:bg-info-bg-hover hover:text-info-text-hover`,
				warning: `border-transparent bg-warning-bg text-warning-text hover:bg-warning-bg-hover hover:text-warning-text-hover`,
			},
		},
		defaultVariants: {
			variant: `default`,
		},
	},
)

export interface BadgeProps
	extends React.HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
	return (
		<div className={cn(badgeVariants({ variant }), className)} {...props} />
	)
}

export { Badge, badgeVariants }
